<form novalidate #propertyContactDetailsSectionForm="ngForm">
    <tg-row
        *ngIf="draftLoaded$ | async"
        class="property-contact-details-section"
    >
        <tg-col md="9" sm="12">
            <tg-row>
                <tg-col sm="12">
                    <h2>Your details</h2>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4" sm="12">
                    <tg-input-container label="Mobile">
                        <input
                            ngModel
                            name="mobilePhone"
                            tgTextInput
                            tgInputMask
                            (blur)="publish()"
                            (change)="
                                onInputChange(
                                    $event.target.value,
                                    'mobile'
                                )
                            "
                            [(ngModel)]="
                                draftData.propertyInformation.mobile
                            "
                            [type]="
                                validation.propertyInformation.mobile
                                    ?.type || 'text'
                            "
                            [validation]="
                                validation.propertyInformation.mobile
                                    | toValidator
                            "
                            [disabled]="
                                draftData.propertyInformation.shouldContactAgent
                            "
                        />
                        <tg-input-mask-pattern
                            [regex]="mobilePhoneNumberRegex"
                            pattern="*** *** *****"
                            allow="[0-9]"
                        >
                        </tg-input-mask-pattern>
                    </tg-input-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4" sm="12">
                    <tg-input-container label="Home">
                        <input
                            ngModel
                            name="homePhone"
                            tgTextInput
                            tgInputMask
                            (blur)="publish()"
                            (change)="
                                onInputChange($event.target.value, 'landLine')
                            "
                            [(ngModel)]="
                                draftData.propertyInformation.landLine
                            "
                            [type]="
                                validation.propertyInformation.landLine
                                    ?.type || 'text'
                            "
                            [validation]="
                                validation.propertyInformation.landLine
                                    | toValidator
                            "
                            [disabled]="
                                draftData.propertyInformation.shouldContactAgent
                            "
                        />
                        <tg-input-mask-pattern
                            [regex]="homePhoneNumberRegex"
                            pattern="** *** ****"
                            allow="[0-9]"
                        >
                        </tg-input-mask-pattern>
                    </tg-input-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4" sm="12">
                    <tg-select-container label="Best contact time">
                        <select
                            tgSelect
                            ngModel
                            name="contactTime"
                            (change)="
                                onSelectChange(
                                    draftData.propertyInformation.contactTimes,
                                    'contactTime'
                                );
                                publish()
                            "
                            [(ngModel)]="
                                draftData.propertyInformation.contactTimes
                            "
                            [disabled]="
                                draftData.propertyInformation.shouldContactAgent
                            "
                        >
                            <option [ngValue]="null" selected></option>
                            <option
                                *ngFor="let time of metadata.contactTimes"
                                [ngValue]="time.value"
                            >
                                {{ time.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="8" sm="12">
                    <tg-checkbox
                        name="shouldContactAgent"
                        label="Potential buyers should contact my real estate agent"
                        (change)="onShouldContactAgentChange($event.value)"
                        [(ngModel)]="
                            draftData.propertyInformation.shouldContactAgent
                        "
                        [validation]="
                            validation.propertyInformation.shouldContactAgent
                                | toValidator
                        "
                        [disabled]="draftData.propertyInformation.isPropertyAgent"
                    >
                    </tg-checkbox>
                    <tg-row
                        *ngIf="draftData.propertyInformation.shouldContactAgent"
                    >
                        <tg-col>
                            <div class="o-nested-inputs-container">
                                <tg-row>
                                    <tg-col>
                                        <tg-input-container
                                            label="Agency name"
                                            showRemainingCharacters="false"
                                        >
                                            <input
                                                tgTextInput
                                                name="agentAgency"
                                                type="text"
                                                (blur)="publish()"
                                                (change)="
                                                    onInputChange(
                                                        $event.target.value,
                                                        'agentAgency'
                                                    )
                                                "
                                                [(ngModel)]="
                                                    draftData
                                                        .propertyInformation
                                                        .agentAgency
                                                "
                                                [validation]="
                                                    validation
                                                        .propertyInformation
                                                        .agentAgency
                                                        | toValidator
                                                "
                                                placeholder="e.g. Harcourts"
                                            />
                                        </tg-input-container>
                                        <tg-input-container
                                            label="Agent name"
                                            showRemainingCharacters="false"
                                        >
                                            <input
                                                tgTextInput
                                                name="agentName"
                                                type="text"
                                                (blur)="publish()"
                                                (change)="
                                                    onInputChange(
                                                        $event.target.value,
                                                        'agentName'
                                                    )
                                                "
                                                [(ngModel)]="
                                                    draftData
                                                        .propertyInformation
                                                        .agentName
                                                "
                                                [validation]="
                                                    validation
                                                        .propertyInformation
                                                        .agentName | toValidator
                                                "
                                            />
                                        </tg-input-container>
                                    </tg-col>
                                </tg-row>
                                <tg-row>
                                    <tg-col sm="12">
                                      <p class="property-contact-details-section__contact-detail-copy">
                                        Please enter at least one of the following contact details
                                      </p>
                                    </tg-col>
                                </tg-row>
                                <tg-row>
                                    <tg-col sm="12" md="6">
                                        <tg-input-container
                                            label="Agent mobile phone"
                                            class="hide-optional-label"
                                        >
                                            <input
                                                ngModel
                                                name="agentMobile"
                                                tgTextInput
                                                tgInputMask
                                                (blur)="onAgentDetailChange()"
                                                (change)="
                                                    onInputChange(
                                                        $event.target.value,
                                                        'agentMobile'
                                                    )
                                                "
                                                [(ngModel)]="
                                                    draftData
                                                        .propertyInformation
                                                        .agentMobile
                                                "
                                                [type]="
                                                    validation
                                                        .propertyInformation
                                                        .agentMobile?.type ||
                                                    'text'
                                                "
                                                [validation]="
                                                    validation
                                                        .propertyInformation
                                                        .agentMobile
                                                        | toValidator
                                                "
                                            />
                                            <tg-input-mask-pattern
                                                [regex]="mobilePhoneNumberRegex"
                                                pattern="*** *** *****"
                                                allow="[0-9]"
                                            >
                                            </tg-input-mask-pattern>
                                        </tg-input-container>
                                    </tg-col>
                                    <tg-col sm="12" md="6">
                                        <tg-input-container
                                            label="Agent landline"
                                            class="hide-optional-label"
                                        >
                                            <input
                                                ngModel
                                                name="agentLandline"
                                                tgTextInput
                                                tgInputMask
                                                (blur)="onAgentDetailChange()"
                                                (change)="
                                                    onInputChange(
                                                        $event.target.value,
                                                        'agentLandline'
                                                    )
                                                "
                                                [(ngModel)]="
                                                    draftData
                                                        .propertyInformation
                                                        .agentLandLine
                                                "
                                                [type]="
                                                    validation
                                                        .propertyInformation
                                                        .agentLandLine?.type ||
                                                    'text'
                                                "
                                                [validation]="
                                                    validation
                                                        .propertyInformation
                                                        .agentLandLine
                                                        | toValidator
                                                "
                                            />
                                            <tg-input-mask-pattern
                                                [regex]="homePhoneNumberRegex"
                                                pattern="** *** ****"
                                                allow="[0-9]"
                                            >
                                            </tg-input-mask-pattern>
                                        </tg-input-container>
                                    </tg-col>
                                </tg-row>
                                <tg-row>
                                    <tg-col>
                                        <tg-input-container
                                            label="Agent email address"
                                            class="hide-optional-label"
                                        >
                                            <input
                                                tgTextInput
                                                name="agentEmail"
                                                type="email"
                                                (blur)="onAgentDetailChange()"
                                                (change)="
                                                    onInputChange(
                                                        $event.target.value,
                                                        'agentEmail'
                                                    )
                                                "
                                                [(ngModel)]="
                                                    draftData
                                                        .propertyInformation
                                                        .agentEmail
                                                "
                                                email
                                            />
                                        </tg-input-container>
                                    </tg-col>
                                </tg-row>
                                <tg-row *ngIf="hasErrorInAgentDetails">
                                    <tg-col>
                                        <p
                                            class="
                                                property-contact-details-section__validate-fail
                                            "
                                        >
                                            At least one phone number or agent
                                            email address is required
                                        </p>
                                    </tg-col>
                                </tg-row>
                            </div>
                        </tg-col>
                    </tg-row>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="8" sm="12">
                    <tg-radio-group
                        label="Are you a registered property agent?"
                        class="
                            property-contact-details-section__registered-agent-group
                        "
                        ngModel
                        name="Radio group name"
                        (change)="onIsPropertyAgentChange($event.value)"
                        [(ngModel)]="
                            draftData.propertyInformation.isPropertyAgent
                        "
                        [validation]="
                            validation.propertyInformation.isPropertyAgent
                                | toValidator
                        "
                    >
                        <tg-radio-item
                            [value]="true"
                            [disabled]="draftData.propertyInformation.shouldContactAgent"
                            label="Yes"
                            class="
                                property-contact-details-section__registered-agent-option
                            "
                        >
                        </tg-radio-item>
                        <tg-radio-item
                            [value]="false"
                            label="No"
                            class="
                                property-contact-details-section__registered-agent-option
                            "
                        >
                        </tg-radio-item>
                    </tg-radio-group>
                    <tg-row
                        *ngIf="draftData.propertyInformation.isPropertyAgent"
                    >
                        <tg-col>
                            <div class="o-nested-inputs-container">
                                <tg-input-container
                                    label="{{
                                        validation.propertyInformation.name
                                            ?.name
                                    }}"
                                    showRemainingCharacters="false"
                                >
                                    <input
                                        tgTextInput
                                        name="name"
                                        type="text"
                                        (blur)="publish()"
                                        [(ngModel)]="
                                            draftData.propertyInformation.name
                                        "
                                        [validation]="
                                            validation.propertyInformation.name
                                                | toValidator
                                        "
                                    />
                                </tg-input-container>
                                <tg-input-container
                                    label="{{
                                        validation.propertyInformation.agency
                                            ?.name
                                    }}"
                                    showRemainingCharacters="false"
                                >
                                    <input
                                        tgTextInput
                                        name="agency"
                                        type="text"
                                        (blur)="publish()"
                                        placeholder="e.g. Harcourts"
                                        [(ngModel)]="
                                            draftData.propertyInformation.agency
                                        "
                                        [validation]="
                                            validation.propertyInformation
                                                .agency | toValidator
                                        "
                                    />
                                </tg-input-container>
                            </div>
                        </tg-col>
                    </tg-row>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col>
                    <p class="p-secondary-copy">
                        Licensed agents are required to disclose their status
                        under the Real Estate Agents Act 2008.
                    </p>
                </tg-col>
            </tg-row>
        </tg-col>
    </tg-row>
</form>
